const ErrorMessage: React.FC<{ message: string; className?: string }> = ({ message, className, ...props }) => (
  <div
    className={`text-[var(--sematicErrorColor500)] font-normal text-[12px] leading-[16px] mt-1 ${className}`}
    {...props}
  >
    {message}
  </div>
);
export default ErrorMessage;
